/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import isAbortedRequest from '../../helpers/isAbortedRequest';

export const SEARCH_RESULT_SIZE = 50;

export const searchByQuery = createAsyncThunk(
  'productCategories/searchByQuery',
  async ({ query } = {}, { signal, extra: { sdk, Logger } }) => {
    const trimmedQuery = String(query || '').trim();
    if (!trimmedQuery) return [];

    try {
      const { data } = await sdk.productCategories.search(
        { query: trimmedQuery, size: SEARCH_RESULT_SIZE },
        signal,
      );
      return data || [];
    } catch (error) {
      if (isAbortedRequest(error, signal)) {
        return [];
      }

      Logger.error(new Error('Error product categories search'), { error }, [
        'SearchProductCategoriesFailed',
        { errorMessage: 'Product categories can not be searched on backend.' },
      ]);
      throw error;
    }
  },
);
